import { render, staticRenderFns } from "./updateTemplate.vue?vue&type=template&id=f1d32b18"
import script from "./updateTemplate.vue?vue&type=script&lang=js"
export * from "./updateTemplate.vue?vue&type=script&lang=js"
import style0 from "./updateTemplate.vue?vue&type=style&index=0&id=f1d32b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports